import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { dmsState } from '@/app/store'
import { Loader } from '@/shared'
import { routes } from '@Config/config'

import { EmptyContent } from '../EmptyContent/EmptyContent'

import style from './Companies.module.scss'
import { List } from './List/List'

export const Companies = observer(() => {
    const navi = useNavigate()

    useEffect(
        () => () => {
            dmsState.onSetCompanyContracts(null)
            dmsState.onSetCompanyPrograms(null)
        },
        []
    )

    if (!dmsState.companiesList) {
        return <Loader className={style.loader} />
    }

    if (dmsState.companiesList.length === 0) {
        return (
            <EmptyContent
                title='Список Страховых компаний пуст'
                action={{
                    title: 'Добавить первую компанию',
                    callback: () => navi(`${routes.DMSM}/companies/addCompany`)
                }}
            />
        )
    }

    return <List />
})
